import { Button, FlexRow, OverflowText } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

/**
 * Props for the CalculationSection component.
 */
interface CalculationSectionProps {
	/** The count of items selected. */
	count: number;
	/** The function to clear all items in the selection. */
	clearComposition: VoidFunction;
}

const CalculationSection: FunctionComponent<CalculationSectionProps> = ({ count, clearComposition }) => {
	return (
		<FlexRow alignItems="flex-end">
			<OverflowText
				grow
				res="ItemsSelected"
				resParams={[count]}
				variant="h5"
			/>
			<Button
				design="link"
				onClick={clearComposition}
				res="DeleteAll"
				sx={{ alignItems: "flex-end", paddingBottom: 0 }}
			/>
		</FlexRow>
	);
};

export default CalculationSection;